import { memo } from 'react';
import { propsAreEqual } from 'utils/util';

const FitterLabel = ({ label }) => {
  return <div className="me-2">{label}</div>;
};

export default memo(FitterLabel, propsAreEqual);
